module.exports = __webpack_public_path__ + "static/img/20080026C2.098a1163.png";